import { axiosClient } from "@/lib/axios";
import { HttpError } from "@/types/error";
import { PublicPlaylist } from "@classview/shared-types";
import { UseQueryOptions, useQuery } from "@tanstack/react-query";

const getPlaylists = async (orgId: string): Promise<PublicPlaylist[]> => {
  const response = await axiosClient.get(`${orgId}/playlists`);
  return response.data;
};

export function playlistsQueryKey(orgId: string) {
  return ["playlists", orgId];
}

export function usePlaylists(
  orgId: string,
  queryOptions?: Partial<UseQueryOptions<PublicPlaylist[], HttpError>>,
) {
  return useQuery({
    queryKey: playlistsQueryKey(orgId),
    queryFn: () => getPlaylists(orgId),
    ...queryOptions,
  });
}
